import { AxiosError } from "axios";

import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import adminAxios from "@/lib/axios";

export interface IRichTextEditor {
  id?: number | string;
  page_id?: number;
  component_id?: number;
  content?: string;
  background_color?: string;
  enable_padding?: boolean;
  padding_x?: number | string;
  padding_y?: number | string;
  status?: boolean;
}

export async function createRichTextEditor(payload: Partial<IRichTextEditor>) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.RICH_TEXT_EDITOR.CREATE,
      payload
    );

    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateRichTextEditor(
  id: number,
  payload: Partial<IRichTextEditor>
) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.RICH_TEXT_EDITOR.UPDATE(id),
      payload
    );

    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}


